module.exports = __webpack_public_path__ + "static/media/login-background.10e323a2.jpg";